import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

// Connects to data-controller="choices"
export default class extends Controller {
  static targets = ["select"]
  static values = {
    shouldSort: { type: Boolean, default: false },
    noResultsText: { type: String, default: '見つかりません' },
    placeholder: { type: String }
  }

  connect() {
    this.#initChoices()
  }

  disconnect() {
    this.#destroyChoices()
  }

  setValue(value) {
    if (this.choiceInstance) {
      this.choiceInstance.setChoiceByValue(value.toString())
    }
  }

  // Public methods for orchestrators that need to cleanly serialize the DOM
  // (e.g., teams_cache snapshotting) without nested wrapper artifacts.
  destroyChoices() {
    this.#destroyChoices()
  }

  reinitChoices() {
    if (!this.choiceInstance) this.#initChoices()
  }

  #initChoices() {
    this.choiceInstance = new Choices(this.selectTarget, {
      shouldSort: this.shouldSortValue,
      itemSelectText: '',
      noResultsText: this.noResultsTextValue,
      placeholder: this.hasPlaceholderValue,
      placeholderValue: this.placeholderValue,
    })
  }

  #destroyChoices() {
    if (this.choiceInstance) {
      this.choiceInstance.destroy()
      this.choiceInstance = null
    }
  }
}
